import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BASE}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // Keep token if request is to /auth/me on load; otherwise clear
      const url = err.config?.url || "";
      if (!url.includes("/auth/me")) {
        localStorage.removeItem("token");
      }
    }
    return Promise.reject(err);
  }
);
